import { defineStore } from 'pinia'

export const usePolygonState = defineStore('polygonState', {
  state: () => ({
    isPolygonFormed: false,
    geoJsonPolygon: null,
    polygonLayer: null,
    toWayline: false
  }),
  actions: {
    setIsFormed (value) {
      // replace entire modalForm with new object
      this.isPolygonFormed = value
    },
    setGeoJsonPolygon (geoJson) {
      this.geoJsonPolygon = geoJson
    }

  }
})
